import { useContext } from "react";
import useSWRImmutable from "swr/immutable";
import Select from "@/components/Select/Select";
import { CalculatorContext } from "./CalculatorContext";

const fetcher = (url) => fetch(url).then((res) => res.json());

const CalculatorSelect = ({ erstzulassung, kilometer }) => {
  const { setCalculatorParams, calculatorParams } =
    useContext(CalculatorContext);

  const url =
    calculatorParams.type === "leasing"
      ? `${process.env.NEXT_PUBLIC_API_URL}finance-calculator/?type=leasing_mileages&initialRegistration=${erstzulassung}&mileage=${kilometer}&term=${calculatorParams.term}`
      : null;

  const { data: dropdownValues, error } = useSWRImmutable(url, fetcher);

  const handleValueChange = (value) => {
    setCalculatorParams((prevParams) => ({
      ...prevParams,
      contractualMileage: value,
    }));
  };

  if (calculatorParams.type !== "leasing") {
    return null; // Do nothing if we are not dealing with a leasing type
  }

  if (error) return <div>Keine Laufleistung verfügbar.</div>;

  return (
    <div
      className={`flex flex-wrap [&>div]:bg-gray-100 max-md:[&>div>select]:opacity-100 max-md:[&>div>select]:bg-gray-100 max-md:[&>div>select]:pl-6 max-md:[&>div>select]:h-10 max-md:mb-8   ${
        calculatorParams.type === "financing" && "hidden"
      }`}
    >
      <label
        className={`${
          calculatorParams.type === "financing" && "opacity-50 "
        } mb-4`}
      >
        <p className="text-3xl  text-blue-dark font-semibold">
          Laufleistung pro Jahr
        </p>
      </label>
      <Select
        showNativeSelectMobile={false}
        value={calculatorParams.contractualMileage}
        ariaLabel="Sortieren"
        iconClass="!absolute lg:text-blue-light !right-0 lg:!right-7 lg:ml-0 ml-4 xl:!rotate-90 !-rotate-90 opacity-1  "
        iconType="sort"
        onValueChange={handleValueChange}
        className="max-h-[45px] items-center flex justify-center max-md:!bg-transparent border-none w-full lg:!text-gray-600 !text-center !pr-5 md:!pr-11 !z-[600] font-semibold "
      >
        {dropdownValues?.map(
          ({ annualMileageInKm, contractualMileageInKm }, index) => (
            <Select.Item
              key={`${index}-${contractualMileageInKm}`}
              value={contractualMileageInKm}
              label={annualMileageInKm}
            >
              {annualMileageInKm} km
            </Select.Item>
          )
        )}
      </Select>
      <p className="text-sm text-white font-semibold">
        Laufleistung (in 5.000er Schritten)
      </p>
    </div>
  );
};

export default CalculatorSelect;
